const apiFetch = async (url, options = {}) => {
  let response;

  try {
    response = await fetch(url, {
    //  credentials: 'include',
      ...options,
    });
  } catch (networkError) {
    // 🚨 Network / CORS / DNS / SSL error

    throw 'Network error. Please check your connection.';
  }

  // 🔴 SESSION EXPIRED (only if response exists)
  if (response.status === 531) {
    throw 'Session expired. Please login again.';
  }

  // ❌ HTTP errors
  if (!response.ok) {
    const text = await response.text();
    throw text || `HTTP_ERROR_${response.status}`;
  }

  if (response.status === 204) return null;
return response;
//   const contentType = response.headers.get('content-type');
//   if (contentType?.includes('application/json')) {
//     return response.json();
//   }

//   return response.text();
};

export default apiFetch;
